export default {"src":"/_next/static/media/section-title-underline-decoration.25fa90ef.svg","height":13,"width":153};